import { render, staticRenderFns } from "./MusicOnHoldSettings.vue?vue&type=template&id=2f783814&"
import script from "./MusicOnHoldSettings.vue?vue&type=script&lang=js&"
export * from "./MusicOnHoldSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports